import React, { Component } from "react";
import { Col } from "react-grid-system";
import { Button, Dropdown } from "semantic-ui-react";
import { ProductModel } from "../../entities/admin.product.model";
import ProductItem from "../product-item/product-item";
import "./catalog-products.scss";

interface ProductsProps {
  products: ProductModel[];
}

interface ProductsState {
  searchText: string;
  filteredProducts: ProductModel[];
  sale: boolean;
  notSale: boolean;
  searchValue: string;
  // parameters
  brandSet: string[];
  usageSet: string[];
  typeSet: string[];
  sortOptions: any[];
  sortValue: string;
  getTypeCount?: (type: string) => number;
  getUsageCount?: (usage: string) => number;
  getBrandCount?: (brand: string) => number;
  getSaleCount?: (sale: string) => number;
  getNotSaleCount?: (notSale: string) => number;
}

class CatalogProducts extends Component<ProductsProps, ProductsState> {
  unitValue: any = { unit: "", min: 0, max: 0 };
  filteredBrands: Set<String> = new Set();
  filteredUsages: Set<String> = new Set();
  filteredTypes: Set<String> = new Set();

  constructor(props: any) {
    super(props);
    this.state = {
      searchText: "",
      filteredProducts: [],
      sale: false,
      notSale: false,
      searchValue: "",
      brandSet: [],
      usageSet: [],
      typeSet: [],
      sortOptions: [
        { key: "lastfirst", value: "lastfirst", text: "Шинэ нь эхэндээ" },
        { key: "priceup", value: "priceup", text: "Үнэ - багаас их" },
        { key: "pricedown", value: "pricedown", text: "Үнэ - ихээс бага" },
        { key: "saleup", value: "saleup", text: "Хямдарсан" },
      ],
      sortValue: "lastfirst",
    };

    this.onSortChange = this.onSortChange.bind(this);
  }

  componentDidMount() {
    let sale = this.isSaleFilterActive();
    let searchValue = decodeURI(this.hasSearchValue() || "");
    let products = this.props.products;
    let querySortValue = this.isSortQueryActive();
    this.setState(
      {
        filteredProducts: products,
        sale: sale,
        searchValue: searchValue,
        sortValue: querySortValue || "lastfirst",
      },
      () => {
        this.applyFilter();
      }
    );
    this.prepareFilters(this.props);
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.products && nextProps.products !== this.props.products) {
      let products: ProductModel[] = [];
      for (let p of nextProps.products) {
        if (!p.active) continue;
        products.push(p);
      }
      let sale = this.isSaleFilterActive();
      let searchValue = decodeURI(this.hasSearchValue() || "");
      // Create a copy before sorting to avoid mutating
      const productsCopy = [...products];
      productsCopy.sort((a: any, b: any) => {
        if (
          (a.warehouseCount <= 0 && b.warehouseCount <= 0) ||
          (a.warehouseCount > 0 && b.warehouseCount > 0)
        ) {
          // id desc
          return a.id < b.id ? 1 : -1;
        } else {
          // stocked first
          return a.warehouseCount <= 0 ? 1 : -1;
        }
      });
      this.setState(
        { filteredProducts: productsCopy, sale: sale, searchValue: searchValue },
        () => {
          this.applyFilter();
        }
      );
    }
    this.prepareFilters(nextProps);
  }

  prepareFilters(props: any) {
    if (props.products && props.products.length > 0) {
      let brandSet = new Set<string>();
      let usageSet = new Set<string>();
      let typeSet = new Set<string>();

      for (let product of props.products) {
        // brands
        if (!brandSet.has(product.brandName)) {
          brandSet.add(product.brandName);
        }
        // usages
        for (let usage of product.usages) {
          if (!usageSet.has(usage)) {
            usageSet.add(usage);
          }
        }
        // types
        for (let ptype of product.types) {
          if (!typeSet.has(ptype)) {
            typeSet.add(ptype);
          }
        }
      }
      // this.priceValue = { min: priceMin, max: priceMax };
      this.setState({
        brandSet: Array.from(brandSet.values()),
        usageSet: Array.from(usageSet.values()),
        typeSet: Array.from(typeSet.values()),
      });
    }
  }

  onFilterChange(e?: any) {
    if (e) {
      if (e.sale !== undefined) {
        this.setState({ sale: e.sale }, () => this.applyFilter());
      }
      if (e.notSale !== undefined) {
        this.setState({ notSale: e.notSale }, () => this.applyFilter());
      }
      if (e.brands !== undefined) {
        this.filteredBrands = e.brands;
        this.applyFilter();
      }
      if (e.usages !== undefined) {
        this.filteredUsages = e.usages;
        this.applyFilter();
      }
      if (e.types !== undefined) {
        this.filteredTypes = e.types;
        this.applyFilter();
      }
      
    }
  }

  applyFilter() {
    let filteredProducts = this.props.products.filter((p: any) => {
      // sale
      if (this.state.sale && !p.saleActive) return false;
      // name
      if (this.state.searchValue) {
        if (
          String(p.name)
            .toLowerCase()
            .indexOf(this.state.searchValue.toLowerCase()) === -1
        ) {
          return false;
        }
      }
      //notsale
      if (this.state.notSale && p.saleActive) return false;
      // brand
      if (
        this.filteredBrands &&
        this.filteredBrands.size > 0 &&
        !this.filteredBrands.has(p.brandName)
      ) {
        return false;
      }
      // usage
      if (this.filteredUsages && this.filteredUsages.size > 0) {
        if (!p.usages) return false;
        let usageMatches = false;
        this.filteredUsages.forEach((fusage) => {
          for (let usage of p.usages) {
            if (fusage === usage) {
              usageMatches = true;
              break;
            }
          }
        });
        if (!usageMatches) return false;
      }
      // type
      if (this.filteredTypes && this.filteredTypes.size > 0) {
        if (!p.types) return false;
        let typeMatches = false;
        this.filteredTypes.forEach((ftype) => {
          for (let type of p.types) {
            if (ftype === type) {
              typeMatches = true;
              break;
            }
          }
        });
        if (!typeMatches) return false;
      }
      return true;
    });
    // Create a copy before sorting to avoid mutating state
    const sortedProducts = [...filteredProducts];
    this.sortProducts(sortedProducts, this.state.sortValue);
    this.setState({ filteredProducts: sortedProducts });
  }

  isSaleFilterActive() {
    if (window?.location?.search) {
      let str = String(window?.location?.search);
      let arr: string[] = str.split("?");
      if (arr.length === 0) return false;
      let saleStr = arr[1].toLowerCase();
      if (saleStr && saleStr.indexOf("sale=") !== -1) {
        arr = saleStr.split("sale=");
        saleStr = arr[1];
        if (saleStr) {
          arr = saleStr.split("&");
          saleStr = arr[0];
          if (saleStr) {
            // found sale query param
            if (saleStr === "1") {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  isSortQueryActive() {
    if (window?.location?.search) {
      let str = String(window?.location?.search);
      let arr: string[] = str.split("?");
      if (arr.length === 0) return;
      let queryParam = arr[1].toLowerCase();
      if (queryParam && queryParam.indexOf("sort=") !== -1) {
        arr = queryParam.split("sort=");
        queryParam = arr[1];
        if (queryParam) {
          arr = queryParam.split("&");
          queryParam = arr[0];
          if (queryParam) {
            return queryParam;
          }
        }
      }
    }
  }

  hasSearchValue() {
    if (window?.location?.search) {
      let arr = String(window?.location?.search).split("?");
      if (arr.length === 0) return;
      let str = arr[1].toLowerCase();
      if (str && str.indexOf("value=") !== -1) {
        arr = str.split("value=");
        str = arr[1];
        if (str) {
          arr = str.split("&");
          str = arr[0];
          if (str) {
            // found sale query param
            if (str) {
              return str;
            }
          }
        }
      }
    }
  }

  onSortChange(e: any, drop: any) {
    if (drop.value !== this.state.sortValue) {
      if (this.state.filteredProducts?.length > 0) {
        // Create a copy of the array to avoid mutating state directly
        const sortedProducts = [...this.state.filteredProducts];
        this.sortProducts(sortedProducts, drop.value);
        this.setState({ 
          sortValue: drop.value,
          filteredProducts: sortedProducts
        });
      } else {
        this.setState({ sortValue: drop.value });
      }
    }
  }

  sortProducts(products: any[], sortValue: string) {
    if (sortValue === "lastfirst") {
      products.sort((a: any, b: any) => {
        if (
          (a.warehouseCount <= 0 && b.warehouseCount <= 0) ||
          (a.warehouseCount > 0 && b.warehouseCount > 0)
        ) {
          // id desc
          return a.id < b.id ? 1 : -1;
        } else {
          // stocked first
          return a.warehouseCount <= 0 ? 1 : -1;
        }
      });
    } else if (sortValue === "priceup") {
      products.sort((a: any, b: any) => {
        if (
          (a.warehouseCount <= 0 && b.warehouseCount <= 0) ||
          (a.warehouseCount > 0 && b.warehouseCount > 0)
        ) {
          let priceA = a.saleActive ? a.salePrice : a.price;
          let priceB = b.saleActive ? b.salePrice : b.price;
          // price asc
          return priceA < priceB ? -1 : 1;
        } else {
          // stocked first
          return a.warehouseCount <= 0 ? 1 : -1;
        }
      });
    } else if (sortValue === "pricedown") {
      products.sort((a: any, b: any) => {
        if (
          (a.warehouseCount <= 0 && b.warehouseCount <= 0) ||
          (a.warehouseCount > 0 && b.warehouseCount > 0)
        ) {
          let priceA = a.saleActive ? a.salePrice : a.price;
          let priceB = b.saleActive ? b.salePrice : b.price;
          // price desc
          return priceA < priceB ? 1 : -1;
        } else {
          // stocked first
          return a.warehouseCount <= 0 ? 1 : -1;
        }
      });
    } else if (sortValue === "saleup") {
      products.sort((a: any, b: any) => {
        if (
          (a.warehouseCount <= 0 && b.warehouseCount <= 0) ||
          (a.warehouseCount > 0 && b.warehouseCount > 0)
        ) {
          if (a.saleActive === b.saleActive) {
            let priceA = a.saleActive ? a.salePrice : a.price;
            let priceB = b.saleActive ? b.salePrice : b.price;
            // price asc
            return priceA < priceB ? -1 : 1;
          }
          // sale first
          return a.saleActive ? -1 : 1;
        } else {
          // stocked first
          return a.warehouseCount <= 0 ? 1 : -1;
        }
      });
    }
    return products;
  }

  filterProducts() {
    const search = this.state.searchText.trim().toLowerCase();
    if (!search) {
      this.setState({ filteredProducts: this.props.products });
      return;
    }
    const filtered = this.props.products.filter((p: any) => {
      return (
        p.name?.toLowerCase().includes(search) ||
        p.brandName?.toLowerCase().includes(search)
      );
    });
    this.setState({ filteredProducts: filtered });
  }

  onInputChange(e: any) {
    this.setState({ searchText: e.target.value })
    setTimeout(() => {
      this.filterProducts();
    });
  };

  handleKeyDown(e: any) {
    if (e.key === "Enter") {
      this.filterProducts()
    }
  };

  render() {
    return (
      <section
        className={
          "catalog-products-container bordered"
        }
        id='products-content'>

        <div className='products-content'>
          <div className='products-title'>
            <div className='products-count'>
              Нийт
              <span> | {this.state.filteredProducts.length} бүтээгдэхүүн</span>
            </div>
            <div className='filter-dropdown'>
              <Dropdown
                icon="chevron down"
                options={this.state.sortOptions}
                defaultValue={this.state.sortValue}
                onChange={this.onSortChange}
              />
            </div>
          </div>

          <div className='search-input'>
            <input
              type='text'
              autoComplete='true'
              value={this.state.searchText}
              onChange={(e) => this.onInputChange(e)}
              onKeyDown={this.handleKeyDown}
              placeholder='Бүтээгдэхүүн хайх'
              className='input'
            />
            <Button
              className='icon icon-search cursor search-button'
              ></Button>
          </div>

          <div className='products-body'>
            {this.state.filteredProducts &&
            this.state.filteredProducts.length > 0 ? (
              this.state.filteredProducts.map((product: any) => {
                return (
                  <Col
                    className='product-item-col'
                    xs={6}
                    sm={4}
                    md={3}
                    lg={3}
                    key={`product-${product.id}`}>
                    <ProductItem product={product} />
                  </Col>
                );
              })
            ) : (
              <div className='no-product'>Бүтээгдэхүүн олдсонгүй</div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default CatalogProducts;
